import { ArrowBack, ArrowForward } from "@mui/icons-material";
import * as MUI from "@mui/material";
import { Fragment, useState } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useIsMobile } from "../../../../utils/Functions";
import { StepIcon } from "../../../appointments/singleView/components/utils/FinishMeetingUtils";
import InpatientStayAntiParasiteStep from "./InpatientStaySteps/InpatientStayAntiParasiteStep";
import InpatientStayInfoStep from "./InpatientStaySteps/InpatientStayInfoStep";
import InpatientStayOveviewStep from "./InpatientStaySteps/InpatientStayOveviewStep";
import InpatientStayVaccinationsStep from "./InpatientStaySteps/InpatientStayVaccinationsStep";
import KeyboardDoubleArrowRight from '@mui/icons-material/KeyboardDoubleArrowRight';
import KeyboardDoubleArrowLeft from '@mui/icons-material/KeyboardDoubleArrowLeft';

export default function AddInpatientStayStepper({
  handleCloseDialog,
  selectedPetId,
}) {
  const [activeStep, setActiveStep] = useState(0);
  const isMobile = useIsMobile();
  const { t } = useTranslation();
  const { trigger } = useFormContext();

  const basedSteps = [
    { title: "StayInformation", body: <InpatientStayInfoStep /> },
    { title: "Vaccines", body: <InpatientStayVaccinationsStep /> },
    { title: "AntiParasite", body: <InpatientStayAntiParasiteStep /> },
    {
      title: "Overview",
      body: <InpatientStayOveviewStep selectedPetId={selectedPetId} />,
    },
  ];

  const lastStep = basedSteps.length - 1;

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleLast = () => {
    setActiveStep(lastStep);
  };

  const handleFirst = () => {
    setActiveStep(0);
  }

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const stepValidationFields = {
    0: [],
    1: [],
    2: [], // No validation
    3: [], // No validation
  };

  return (
    <Fragment>
      <MUI.DialogContent
        sx={{
          height: 750,
          px: isMobile ? 0.25 : 3,
        }}
      >
        <MUI.Stepper activeStep={activeStep} alternativeLabel>
          {basedSteps.map((label, index) => (
            <MUI.Step key={index}>
              <MUI.StepLabel StepIconComponent={StepIcon}>
                {t(label.title)}
              </MUI.StepLabel>
            </MUI.Step>
          ))}
        </MUI.Stepper>

        <MUI.Container sx={{ mt: 5, mb: 3 }}>
          {basedSteps[activeStep].body}
        </MUI.Container>
      </MUI.DialogContent>

      <MUI.DialogActions sx={{ px: 4, pb: 3, mt: 4 }}>
        <MUI.Stack spacing={isMobile ? 4 : 2} width="100%">
          {isMobile ? (
            <MUI.Stack
              direction={"row"}
              justifyContent={"center"}
              alignItems={"center"}
              mb={3}
            >
              <MUI.IconButton
                onClick={handleBack}
                disabled={activeStep === 0}
                variant="contained"
                title={t("Back")}
              >
                <ArrowBack fontSize="large" />
              </MUI.IconButton>

              <MUI.IconButton
                onClick={handleNext}
                variant="contained"
                disabled={activeStep === lastStep}
                sx={{ ml: 1 }}
                title={t("Forward")}
              >
                <ArrowForward fontSize="large" />
              </MUI.IconButton>
            </MUI.Stack>
          ) : null}

          <MUI.Stack
            direction="row"
            alignItems="center"
            justifyContent={"space-between"}
            width="100%"
          >
            <MUI.Button
              color="error"
              onClick={handleCloseDialog}
              variant="outlined"
            >
              {t("Close")}
            </MUI.Button>

            {isMobile ? null : (
              <MUI.Box>
                <MUI.IconButton
                  onClick={handleFirst}
                  variant="contained"
                  disabled={activeStep === 0}
                  sx={{ ml: 1 }}
                  title={t("FirstPage")}
                >
                  <KeyboardDoubleArrowLeft />
                </MUI.IconButton>
                <MUI.IconButton
                  onClick={handleBack}
                  disabled={activeStep === 0}
                  variant="contained"
                  title={t("Back")}
                >
                  <ArrowBack />
                </MUI.IconButton>

                <MUI.IconButton
                  onClick={handleNext}
                  variant="contained"
                  disabled={activeStep === lastStep}
                  sx={{ ml: 1 }}
                  title={t("Forward")}
                >
                  <ArrowForward />
                </MUI.IconButton>

                 <MUI.IconButton
                  onClick={handleLast}
                  variant="contained"
                  disabled={activeStep === lastStep}
                  sx={{ ml: 1 }}
                  title={t("LastPage")}
                >
                  <KeyboardDoubleArrowRight />
                </MUI.IconButton>
              </MUI.Box>
            )}

            <MUI.Button
              type="submit"
              form="inpatient-stay-form"
              variant="contained"
              sx={{ ml: 1 }}
            >
              {t("Save")}
            </MUI.Button>
          </MUI.Stack>
        </MUI.Stack>
      </MUI.DialogActions>
    </Fragment>
  );
}
